import { Message } from 'element-ui'

export default function ({ $axios, error: nuxtError, $sentry }) {
  $axios.defaults.timeout = 300000

  $axios.onRequest((config) => {
    // Mock set
    if (process.env.mockBaseURL) {
      if (
        !process.env.mockList ||
        process.env.mockList.some((path) => config.url.includes(path))
      ) {
        config.baseURL = process.env.mockBaseURL
      }
    }

    if (process.env.releaseVersion) {
      config.headers['X-Release-Version'] = process.env.releaseVersion
    }

    return config
  })

  $axios.onError((error) => {
    if ($sentry) {
      const filterNoNeedErros = [
        'Both token and refresh token have expired. Your request was aborted.',
      ]

      if (!filterNoNeedErros.includes(error?.message)) {
        $sentry.captureException(error)
      }
    }

    const { response } = error

    if (response && /4[0-9]{2}/.test(response.status)) {
      const errMsg = response.data?.message || 'エラーが発生しました。'
      // 商品名を列挙する等の長いエラーメッセージは、読み切る前に消えないよう表示時間を延ばし、
      // 読み終わる前に自動で消えても閉じられるようバツボタンを付ける
      const isLongMessage = errMsg.length > 50

      Message({
        message: errMsg,
        type: 'info',
        customClass: 'toast',
        ...(isLongMessage && { duration: 5000, showClose: true }),
      })

      return response
    }

    nuxtError(error)
  })
}
